import React from "react";
import { Addresses } from "utils/Addresses";
import "./InputLabel.scss";

interface Props {
  lable: string;
  forId: string;
  required: boolean;
}

const InputLabel: React.FC<Props> = ({ lable, forId, required }) => {
  return (
    <div className="inputlabelframe">
      {required ? (
        <img
          src={Addresses.icons.REQUIRE_MARK}
          alt="reuireMark"
          className="requiredMark"
        />
      ) : null}
      <label htmlFor={forId} className="inputlabel">
        {lable}
      </label>
    </div>
  );
};

export default InputLabel;
